'use client';

import React from 'react';
import Image from 'next/image';

interface OrganizerLogosProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showLabels?: boolean;
  variant?: 'light' | 'dark';
  layout?: 'row' | 'grid';
}

const LOGOS = [
  {
    src: '/assets/images/Iap-Logo-1784100787736.jpeg',
    alt: 'IAP - Indian Academy of Pediatrics logo',
    label: 'IAP',
  },
  {
    src: '/assets/images/PSG_CCS_R_logo.jpg-1784100811123.jpeg',
    alt: 'PSG CCSR - PSG Centre for Community Service and Research logo',
    label: 'PSG CCSR',
  },
  {
    src: '/assets/images/PHOTO-2026-07-14-12-08-21-1784101428019.jpg',
    alt: 'IAP Coimbatore Branch logo',
    label: 'IAP Coimbatore',
  },
  {
    src: '/assets/images/PSG_IMSR-1784101435936.png',
    alt: 'PSG IMSR - PSG Institute of Medical Sciences and Research logo',
    label: 'PSG IMSR',
  },
];

const SIZE_MAP = {
  sm: { img: 36, gap: 'gap-3' },
  md: { img: 48, gap: 'gap-4' },
  lg: { img: 64, gap: 'gap-6' },
};

export default function OrganizerLogos({
  size = 'md',
  className = '',
  showLabels = false,
  variant = 'light',
  layout = 'row',
}: OrganizerLogosProps) {
  const { img } = SIZE_MAP[size];

  if (layout === 'grid') {
    return (
      <div className={`grid grid-cols-4 gap-3 w-full ${className}`}>
        {LOGOS.map((logo) => (
          <div key={logo.label} className="flex flex-col items-center gap-1.5">
            <div
              className="rounded-lg overflow-hidden bg-white flex items-center justify-center flex-shrink-0 w-full"
              style={{ height: img }}
            >
              <Image
                src={logo.src}
                alt={logo.alt}
                width={img}
                height={img}
                className="object-contain w-full h-full"
                unoptimized
              />
            </div>
            {showLabels && (
              <span
                className={`text-xs font-semibold text-center leading-tight ${
                  variant === 'dark' ? 'text-white/70' : 'text-muted-foreground'
                }`}
              >
                {logo.label}
              </span>
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-between w-full ${className}`}>
      {LOGOS.map((logo) => (
        <div key={logo.label} className="flex flex-col items-center gap-1">
          <div
            className="rounded-lg overflow-hidden bg-white flex items-center justify-center flex-shrink-0"
            style={{ width: img, height: img }}
          >
            <Image
              src={logo.src}
              alt={logo.alt}
              width={img}
              height={img}
              className="object-contain w-full h-full"
              unoptimized
            />
          </div>
          {showLabels && (
            <span
              className={`text-xs font-semibold text-center leading-tight ${
                variant === 'dark' ? 'text-white/70' : 'text-muted-foreground'
              }`}
              style={{ maxWidth: img }}
            >
              {logo.label}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
